<template>
  <div class="rfq-timeline">
    <div class="rfq-step">
      <span class="rfq-marker rfq-marker-done">
        <FontAwesomeIcon icon="check" />
      </span>
      <span>
        {{ $t("company_orders.rfq_timeline.submitted") }} ·
        {{ formatDateTimeIntoDate(createdAt) }}
      </span>
    </div>
    <div class="rfq-step rfq-step-active">
      <span class="rfq-marker rfq-marker-active"></span>
      <span>
        {{
          $t("company_orders.rfq_timeline.quote_expected", {
            date: expectedByLabel,
          })
        }}
      </span>
    </div>
    <div class="rfq-step text-muted">
      <span class="rfq-marker"></span>
      <span>{{ $t("company_orders.rfq_timeline.approval_gate") }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatDateTimeIntoDate } from "@/composables/formatUtils";
import { computed } from "vue";

const props = defineProps<{
  /** Order creation timestamp — the moment the RFQ was submitted to the desk. */
  createdAt: string;
}>();

// The copy promises a quote "usually within one business day".
const nextBusinessDay = (from: Date): Date => {
  const result = new Date(from);
  result.setDate(result.getDate() + 1);
  while (result.getDay() === 0 || result.getDay() === 6) {
    result.setDate(result.getDate() + 1);
  }
  return result;
};

const expectedByLabel = computed(() =>
  formatDateTimeIntoDate(nextBusinessDay(new Date(props.createdAt)))
);
</script>

<style scoped lang="scss">
.rfq-timeline {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  font-size: 0.8125rem;
}

.rfq-step {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.rfq-step-active {
  font-weight: 600;
}

.rfq-marker {
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 1.5px solid var(--phoenix-border-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
}

.rfq-marker-done {
  border-color: var(--phoenix-success);
  color: var(--phoenix-success);
}

.rfq-marker-active {
  border-color: var(--phoenix-primary);
  background: var(--phoenix-primary-bg-subtle);
}
</style>
